export default {
      id: "virtual-access-guide-usage",
      viewBox: "0 0 566.9 566.9",
      url: "/" + "sprite.svg#virtual-access-guide",
      toString: function () {
        return this.url;
      }
    }